import React, { forwardRef, useState } from "react";
import { Switch } from "antd";

const Toggle = (
  { children, onChange, disabled, defaultToggled = true, ...props },
  ref
) => {
  const [toggled, setToggled] = useState(defaultToggled);
  return children({
    toggled,
    toggle: (
      <Switch
        ref={ref}
        checked={toggled}
        disabled={disabled}
        onChange={value => {
          onChange && onChange(value);
          setToggled(value);
        }}
        {...props}
      />
    )
  });
};

export default forwardRef(Toggle);
